import { Button } from "@chakra-ui/react";
import AllRoutes from "./Componenets/AllRoutes";
import "./styles.css";
import KeyBoard from "./Componenets/KeyBoard";

export default function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}
